// removed by extract-text-webpack-plugin
module.exports = {"submitBtn":"_2f7ohMsCD9yZFa_yCAQKK5_0","wrapper":"_2zMGgrJ68ruyVUOoTWE6Bj_0","part":"_2GmXHQS_P6j1gK5RL-lC1H_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a89f2ac","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserInfo/Avatar.vue
// module id = UMlE
// module chunks = 0